import m from "../../geodata/es2015/canadaHigh";
window.am4geodata_canadaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/canadaHigh.js
// module id = null
// module chunks = 